import { render, staticRenderFns } from "./taskToSave.vue?vue&type=template&id=4fbcb341&scoped=true&"
import script from "./taskToSave.vue?vue&type=script&lang=js&"
export * from "./taskToSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbcb341",
  null
  
)

export default component.exports